<template>
  <div class="tarjetas-list">
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Tarjetas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="tarjetas" 
              :fields="tarjetasFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos de la Tarjeta</b-dropdown-item>
                <b-dropdown-item @click.stop="consultarResumenes(data.item)">
                  <i class="fa fa-list"></i>Consultar Vencimientos</b-dropdown-item>
                <b-dropdown-item @click.stop="consultarTarjetasPlasticos(data.item)">
                  <i class="fa fa-list"></i>Consultar Plasticos</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetas/getField',
  mutationType: 'tarjetas/updateField',
});

export default {
  name: 'TarjetasList',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      tarjetasFields: [
        {
          key: 'banco',
        },
        {
          key: 'tarjetaMarca',
          label: 'Marca',
        },
        {
          key: 'numeroCuenta',
          label: 'Nro.Cuenta'
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'tarjetas',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('tarjetas/getTarjetas')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'TarjetaData', 
                          params: { id: item.id }});
    },
    editar (item) {
      this.$router.push({ name: 'TarjetaEdit', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'TarjetaAdd' });
    },
    consultarResumenes(item) {
      this.$router.push({ name: 'TarjetasVencimientos',
                          params: { tarjetaId: item.id }});
    },
    consultarTarjetasPlasticos(item) {
      this.$router.push({ name: 'TarjetasPlasticos',
                          params: { tarjetaId: item.id }});
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .tarjetas-list .registro table td[aria-colindex="1"] {
    width: calc(40% - 15px);
  }
  .tarjetas-list .registro table td[aria-colindex="2"] {
    width: calc(40% - 15px);
  }
  .tarjetas-list .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .tarjetas-list .registro table td[aria-colindex="4"] {
    width: 30px
  }
</style>
